/**
 * Web FO must not surface Electron offline-POS chrome or block features
 * via health-based "offline" gates (API failures surface as normal errors).
 */
export function webOfflinePosChrome(opts: {
  supportsOfflinePos: boolean;
}): {
  canLoginOffline: boolean;
  showOfflineBadge: boolean;
  requireOnlineAlwaysNull: boolean;
} {
  if (opts.supportsOfflinePos) {
    return {
      canLoginOffline: true, // actual value comes from engine gates
      showOfflineBadge: true,
      requireOnlineAlwaysNull: false,
    };
  }
  return {
    canLoginOffline: false,
    showOfflineBadge: false,
    requireOnlineAlwaysNull: true,
  };
}
